export default defineNuxtPlugin(() => {
    const { $bus, $i18n } = useNuxtApp()

    $bus.$on('addToCartSuccess', ({ product, pageName }) => {
        const { CATEGORY_PAGE } = useAppConfig()
        $bus.$emit('notification', {
            message: $i18n.t('Bbk.notification.addedToCart'),
            type: pageName === CATEGORY_PAGE ? 'addToCart' : 'addToCartProduct',
            productName: product.name,
        })
    })

    $bus.$on('cartProductAdded', ({ cartItem }) => {
        $bus.$emit('notification', {
            message: $i18n.t('Bbk.notification.addedToCart'),
            type: 'addToCart',
            productName: cartItem?.product.name,
        })
    })

    $bus.$on('wishlistAddProductsSuccess', () => {
        $bus.$emit('notification', {
            message: $i18n.t('Bbk.notification.addedToWishList'),
            type: 'success',
        })
    })

    $bus.$on('addToCartError', ({ message }) => {
        $bus.$emit('notification', {
            message,
            type: 'error',
        })
    })

    $bus.$on('cartError', ({ message }) => {
        $bus.$emit('notification', {
            message,
            type: 'error',
        })
    })

    $bus.$on('customerAuthorizedError', ({ message }) => {
        $bus.$emit('notification', {
            message,
            type: 'error',
        })
    })
})
